/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  // Force "message" cart behavior on mobile (no full-screen drawer takeover after Add to Cart),
  // while keeping the Theme settings > Cart > Cart type value as-is on desktop.
  if (!window.theme) return;

  var desktopCartType = window.theme.cartType;
  var mobileQuery = window.matchMedia('(max-width: 1023px)');

  function updateCartTypeForViewport() {
    window.theme.cartType = mobileQuery.matches ? 'message' : desktopCartType;
  }

  updateCartTypeForViewport();

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', updateCartTypeForViewport);
  } else {
    mobileQuery.addListener(updateCartTypeForViewport);
  }
})();

(function () {
  // Auto-add the free gift (SKU FREE-GIFT-SIGNUP) to cart when the Klaviyo
  // "Claim Your FREE Car Care Gift" popup (form YzD68w) is submitted.
  var FREE_GIFT_FORM_ID = 'YzD68w';
  var FREE_GIFT_VARIANT_ID = 51657972777238;

  function addFreeGiftToCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var alreadyInCart = cart.items.some(function (item) {
          return item.variant_id === FREE_GIFT_VARIANT_ID;
        });
        if (alreadyInCart) return null;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }] })
        }).then(function (res) { return res.json(); });
      })
      .then(function (result) {
        if (!result) return;
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1 }
        }));
      })
      .catch(function (err) {
        console.error('Free gift auto-add failed:', err);
      });
  }

  window.addEventListener('klaviyoForms', function (event) {
    if (
      event.detail &&
      event.detail.type === 'submit' &&
      event.detail.formId === FREE_GIFT_FORM_ID
    ) {
      addFreeGiftToCart();
    }
  });
})();
